module.exports = __webpack_public_path__ + "static/media/Plural.84376fdd.png";